import { BlankState } from '@domain-group/suit-theme'

import BlankStateImageUrl from './assets/quotes-image.svg'

const explainerNextStepText = (campaignStartDate: string) => {
  if (!campaignStartDate){
    return 'Save your campaign dates above to proceed to the next step.'
  }

  return 'Please add a vendor above to start a new quote.'
}

interface CampaignQuotesBlankStateProps {
  campaignStartDate: string,
  hasContacts: boolean,
}

const CampaignQuotesBlankState = (props: CampaignQuotesBlankStateProps) => {
  const { campaignStartDate, hasContacts } = props

  return (
    <BlankState boxProps={{ marginBottom: 'large' }} imageUrl={BlankStateImageUrl}>
      {/*
       // @ts-expect-error TS2339 */}
      <BlankState.Title>
        No quotes created
        {/*
       // @ts-expect-error TS2339 */}
      </BlankState.Title>

      {/*
       // @ts-expect-error TS2339 */}
      <BlankState.Paragraph>
        Campaign Quotes are used to provide the vendor with a clear understanding of what will be spent during the duration of the marketing campaign.
        {/*
       // @ts-expect-error TS2339 */}
      </BlankState.Paragraph>

      {/*
       // @ts-expect-error TS2339 */}
      <BlankState.Paragraph>
        You can use quotes to track spending and they are useful for reconciliation of orders to ensure that the money spent during the campaign has been paid by the vendor before settlement.
        {/*
       // @ts-expect-error TS2339 */}
      </BlankState.Paragraph>

      {(!campaignStartDate || !hasContacts) && (
        // @ts-expect-error TS2339
        <BlankState.Paragraph>
          <strong>{explainerNextStepText(campaignStartDate)}</strong>
          {/*
         // @ts-expect-error TS2339 */}
        </BlankState.Paragraph>
      )}
    </BlankState>
  )
}

export default CampaignQuotesBlankState
